import { Injectable } from '@angular/core';
import {
    arrayIsSet,
    GlobalVariablesService, objectIsSet, PaginationParserequestType,
    paramsParseQuery,
    stringIsSet,
} from './global-variables.service';
import { LocalStorageService } from './local-storage.service';
import { EMPTY, Observable, of, Subject, Subscription } from 'rxjs';
import { expand, map, switchMap } from 'rxjs/operators';
import Parse from 'parse';
import { fromPromise } from 'rxjs/internal-compatibility';
import { IotDevicesParse } from '../../ParseClass/Iotdevices.Parse';
import {
    getElementByKeyName,
    isPointerConfigurationElement, typeFormValue
} from '../../configurationProperty/configurationPropertyUtils';
import { configurationPropertyIotDevicesParse } from '../../configurationProperty/IoTDeviceConfiguration';
import { ImageService } from './image.service';
import { IoTDeviceConfigurationParse2 } from '../../ParseClass/IoTDeviceConfiguration.Parse';
import { ElementParse } from '../../ParseClass/Element.Parse';
import { PidConfiguration } from "../../ParseClass/pid_configurations";
import { ParseApiService } from "./parse-api.service";
import { SensorElement } from "../../ParseClass/sensor-element";
import { SensorDataTypesParse } from "../../ParseClass/sensor-data-types-parse";

@Injectable({
    providedIn: 'root'
})
export class DeviceIotPageService {

    constructor(private globalVariable: GlobalVariablesService,
        private localStorageService: LocalStorageService,
        private imageService: ImageService,
        private parseApiService: ParseApiService
    ) {
    }

    get progetto() {
        return this.globalVariable.currentProject;
    }

    public get allDevices() {
        return this._allDevices.asObservable();
    }


    // get iotConfigurations$(): Observable<IoTDeviceConfigurationParse[]> {
    //     if (arrayIsSet(this.iotConfigurations)) {
    //         return of(this.iotConfigurations)
    //     } else {
    //         const query = new IoTDeviceConfigurationParse().query();
    //         query.include('device');
    //         return fromPromise(query.find())
    //             .pipe(
    //                 map((iotConfigurations) => {
    //                     this.iotConfigurations = iotConfigurations;
    //                     return iotConfigurations;
    //                 })
    //             )
    //     }
    // }

    get elementsParse$(): Observable<ElementParse[]> {
        if (arrayIsSet(this.elementsParse)) {
            return of(this.elementsParse);
        } else {
            const query = new ElementParse().query();
            query.equalTo('progetto', this.progetto);
            return fromPromise(query.find())
                .pipe(
                    map((elementsParse) => {
                        this.elementsParse = elementsParse as ElementParse[];
                        return this.elementsParse;
                    })
                );
        }
    }

    private subscriptionChangeProject: Subscription | undefined;
    public updatingValue = new Subject<boolean>();
    public configuration = configurationPropertyIotDevicesParse;
    public elementsParse: ElementParse[] | undefined;

    private _allDevices: Subject<IotDevicesParse[]> = new Subject<IotDevicesParse[]>();
    public allDevices$: Observable<IotDevicesParse[]> = this._allDevices.asObservable();

    iotConfigurations: { objectId: string, ioTDeviceConfigurationParse: IoTDeviceConfigurationParse2 }[] = [];
    iotPidConfigurations: { objectId: string, ioTDevicePidConfigurations: PidConfiguration[] }[] = [];

    initChangeProject() {
        this.updatingValue.next(true);
        if (this.subscriptionChangeProject == null) {
            this.subscriptionChangeProject = this.localStorageService.changeProject$.asObservable().pipe(
                switchMap((projectId) => {
                    this.updatingValue.next(true);
                    if (projectId !== undefined) {
                        return this.getDevices2(projectId).pipe(
                            map((elements) => {
                                return { error: false, devices: elements };
                            })
                        );
                    } else {
                        return of({ error: 'nessun_project_id', devices: [] });
                    }
                })
            )
                .subscribe(updated => {
                    this.destroyAllIotConfigurationStored()
                    this.elementsParse = undefined;
                    if (updated.error) {
                        this.setAllDevices([]);
                    } else if (updated.devices) {
                        this.setAllDevices(updated.devices);
                    }
                    this.updatingValue.next(false);
                }, error => {
                    this.destroyAllIotConfigurationStored()
                    this.elementsParse = undefined;
                    this.setAllDevices([]);
                    this.updatingValue.next(false);
                });
        }
        this.localStorageService.projectId = this.localStorageService.projectId;
    }

    destroyChangeProject() {
        if (this.subscriptionChangeProject != null) {
            this.subscriptionChangeProject.unsubscribe();
            this.subscriptionChangeProject = undefined;
        }
    }


    getDevices2(objectId: string | undefined = undefined): Observable<IotDevicesParse[]> {
        const projectId = (stringIsSet(objectId)) ? objectId : this.globalVariable.currentProject?.objectId;
        const requestParams = paramsParseQuery({ houseId: projectId })
        return this.parseApiService.runCloudFunction('web_getProjectEdgeDevices', requestParams,).pipe(map(iotdevices => {
            return iotdevices.map((iot: any) => new IotDevicesParse().fromJson(iot))
        }))
    }

    fetchElement() {
        this.destroyAllIotConfigurationStored();
        this.elementsParse = undefined;
        this.updatingValue.next(true);
        this.getDevices2().subscribe(
            devices => {
                this.setAllDevices(devices);
                this.updatingValue.next(false);
            }, error => {
                this.updatingValue.next(false);
            }
        );

    }

    public setAllDevices(value: IotDevicesParse[]) {
        this._allDevices.next(value);
    }


    getTraduction(keyName: string, object: any) {
        const element = getElementByKeyName(keyName, this.configuration);
        if (element != null && isPointerConfigurationElement(element)) {
            return element.pointer?.getValue(object);
        } else {
            return object.objectId;
        }
    }

    getParseImage(nome: string, base64: string) {
        return new Parse.File(nome, { base64 }, 'image/jpg');
    }

    updateDevice(iotDevices: IotDevicesParse, values: any): Observable<IotDevicesParse> {
        const createParsesFile: { key: string, observable: Observable<any> }[] = [];
        Object.keys(values).forEach(key => {
            if (values[key] != null) {
                let valueToSave;
                const elementConfiguration = getElementByKeyName(key, this.configuration);
                if (elementConfiguration?.typeForm == typeFormValue.IMAGE) {
                    valueToSave = this.getParseImage(values[key].name(), values[key].file);
                } else if (elementConfiguration?.typeForm == typeFormValue.FILE) {
                    const obj = {
                        key,
                        observable: this.imageService.getParseFile(values[key].file, values[key].name)
                    };
                    createParsesFile.push(obj);
                } else {
                    valueToSave = values[key];
                }
                (iotDevices as any)[key] = valueToSave;
            } else {
                iotDevices.unset(key);
            }
        });
        // if (createParsesFile.length > 0) {
        //     return forkJoin(createParsesFile.map(p => p.observable))
        //         .pipe(
        //             switchMap(parsesFile => {
        //                 parsesFile.forEach((parseFile, index) => {
        //                     const key = createParsesFile[index].key;
        //                     iotDevices[key as keyof IotDevicesParse] = parseFile;
        //                 });
        //                 return iotDevices.save$();
        //             }),
        //             updateValueOnParseError(iotDevices)
        //         );
        // } else {
        //     return iotDevices.save$().pipe(
        //         updateValueOnParseError(iotDevices)
        //     );
        // }
        // todo
        return of(iotDevices)

    }

    public destroyDevice(device: IotDevicesParse): Observable<IotDevicesParse> {
        return device.removeEdgeDeviceFromProject$(this.progetto?.objectId!);
    }

    public addElement(device: IotDevicesParse, currentElement: IotDevicesParse[]) {
        const index = currentElement.findIndex(el => el.objectId == device.objectId);
        if (index >= 0) {
            currentElement.splice(index, 1)
        }
        this.setAllDevices(currentElement.concat([device]));
    }

    public removeElement(device: IotDevicesParse, currentElement: IotDevicesParse[]) {
        this.setAllDevices(currentElement.filter(el => el.objectId != device.objectId));
    }


    getIotDeviceConfiguration(iotDevice: IotDevicesParse): Observable<IoTDeviceConfigurationParse2> {
        const requestParams = paramsParseQuery({
            progettoId: this.progetto?.objectId,
            seriale: iotDevice.seriale
        })
        return this.parseApiService.runCloudFunction('getIotConfigurationFromSerialAndProject', requestParams,).pipe(
            map((iotDeviceConfJson) => {
                const iotDeviceConf = new IoTDeviceConfigurationParse2(iotDeviceConfJson);
                return iotDeviceConf;
            })
        )
    }

    getIotConfiguration$(iotDevice: IotDevicesParse): Observable<IoTDeviceConfigurationParse2 | undefined> {
        let iotConfiguration;
        if (arrayIsSet(this.iotConfigurations)) {
            const index = this.iotConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId);
            if (index >= 0) {
                iotConfiguration = this.iotConfigurations[index].ioTDeviceConfigurationParse;
            }
        }
        if (iotConfiguration != null) {
            return of(iotConfiguration);
        } else {
            return this.getIotDeviceConfiguration(iotDevice)
                .pipe(
                    map((iotDeviceConf) => {
                        if (iotDeviceConf != null) {
                            if (arrayIsSet(this.iotConfigurations)) {
                                const index = this.iotConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId)
                                if (index >= 0) {
                                    this.iotConfigurations[index].ioTDeviceConfigurationParse = iotDeviceConf;
                                } else {
                                    this.iotConfigurations.push({
                                        objectId: iotDevice.objectId,
                                        ioTDeviceConfigurationParse: iotDeviceConf
                                    })
                                }
                            } else {
                                this.iotConfigurations = [{
                                    objectId: iotDevice.objectId,
                                    ioTDeviceConfigurationParse: iotDeviceConf
                                }]
                            }
                        }
                        return iotDeviceConf
                    })
                )
        }
    }

    getIotPidConfiguration$(iotDevice: IotDevicesParse): Observable<PidConfiguration[]> {
        const requestParams = paramsParseQuery({
            progettoId: this.progetto?.objectId,
            serial: iotDevice.seriale
        })
        return fromPromise(Parse.Cloud.run('getPidConfigurations', requestParams));
    }

    getIotPidConfigurations$(iotDevice: IotDevicesParse,): Observable<PidConfiguration[] | undefined> {
        let iotConfiguration;
        if (arrayIsSet(this.iotPidConfigurations)) {
            const index = this.iotPidConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId);
            if (index >= 0) {
                iotConfiguration = this.iotPidConfigurations[index].ioTDevicePidConfigurations;
            }
        }

        if (iotConfiguration != null) {
            return of(structuredClone(iotConfiguration));
        } else {
            return this.getIotPidConfiguration$(iotDevice)
                .pipe(
                    map((pidConfiguration) => {
                        if (pidConfiguration != null) {
                            if (arrayIsSet(this.iotPidConfigurations)) {
                                const index = this.iotPidConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId)
                                if (index >= 0) {
                                    this.iotPidConfigurations[index].ioTDevicePidConfigurations = pidConfiguration;
                                } else {
                                    this.iotPidConfigurations.push({
                                        objectId: iotDevice.objectId,
                                        ioTDevicePidConfigurations: pidConfiguration
                                    })
                                }
                            } else {
                                this.iotPidConfigurations = [{
                                    objectId: iotDevice.objectId,
                                    ioTDevicePidConfigurations: pidConfiguration
                                }]
                            }
                        }
                        return structuredClone(pidConfiguration)
                    })
                )
        }
    }

    destroyAllIotConfigurationStored() {
        this.iotConfigurations = [];
        this.iotPidConfigurations = [];
    }

    removeIotConfigurationStored(iotDevice: IotDevicesParse) {
        if (arrayIsSet(this.iotConfigurations)) {
            const index = this.iotConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId)
            if (index >= 0) {
                this.iotConfigurations.splice(index, 1);
            }
        }
    }

    removeIotPidConfigurationStored(iotDevice: IotDevicesParse) {
        if (arrayIsSet(this.iotPidConfigurations)) {
            const index = this.iotPidConfigurations.findIndex(conf => conf.objectId == iotDevice.objectId)
            if (index >= 0) {
                this.iotPidConfigurations.splice(index, 1);
            }
        }
    }

    setPidConfigurations$(projectId: string | undefined, serial: string, pid_configurations: PidConfiguration[]) {
        const progettoId = stringIsSet(projectId) ? projectId : this.progetto?.objectId;
        const pidJson = arrayIsSet(pid_configurations) ? pid_configurations.map(p => p.toJSON()) : []
        const requestParams: Record<string, any> = paramsParseQuery({
            progettoId,
            serial,
            pid_configurations: pidJson,
        })
        return (fromPromise(Parse.Cloud.run('setPidConfigurations', requestParams)) as Observable<any>)
    }


    changeEdgeDeviceSerial$(oldSerial: string, newSerial: string) {
        const requestParams: Record<string, any> = paramsParseQuery({
            oldSerial,
            newSerial
        })
        return (fromPromise(Parse.Cloud.run('changeEdgeDeviceSerial', requestParams)) as Observable<any>)
    }


    // setEdgeDeviceInfo$() {
    //     const params = paramsParseQuery()
    //     //seriale, type, environment, location
    //     return fromPromise(Parse.Cloud.run('setEdgeDeviceInfo', params))
    // }

    // updateConfiguration(ioTDeviceConfigurationParse: IoTDeviceConfigurationParse | undefined, iotDevice: IotDevicesParse, configuration: any) {
    //     if (ioTDeviceConfigurationParse == null) {
    //         ioTDeviceConfigurationParse = new IoTDeviceConfigurationParse();
    //     }
    //     ioTDeviceConfigurationParse.device = iotDevice;
    //     if (configuration != null) {
    //         if (ioTDeviceConfigurationParse.configuration == null) {
    //             ioTDeviceConfigurationParse.configuration = configuration;
    //         } else {
    //             let iotLastConfigurationDevice: any;
    //             if (ioTDeviceConfigurationParse != null && ioTDeviceConfigurationParse.configuration != null) {
    //                 iotLastConfigurationDevice = ioTDeviceConfigurationParse.configuration;
    //             } else {
    //                 iotLastConfigurationDevice = {};
    //             }
    //             Object.keys(configuration).forEach(key => {
    //                 iotLastConfigurationDevice[key] = configuration[key];
    //             })
    //             ioTDeviceConfigurationParse.configuration = iotLastConfigurationDevice;
    //         }
    //     }
    //     return ioTDeviceConfigurationParse.save$()
    //         .pipe(
    //             updateValueOnParseError(ioTDeviceConfigurationParse)
    //         );
    // }
    saveMultipleIotDevices(iotDevices: IotDevicesParse[], connectionOptions: any) {
        const fetchPage$ = (page = 0) => {
            const iotDevice = iotDevices[page]
            const isLast = (page + 1) >= iotDevices.length;
            const progress = Math.ceil((page + 1) / iotDevices.length * 100)
            let options: any = {}
            if (iotDevice.configuration && iotDevice.configuration.configuration) {
                options = iotDevice.configuration.configuration
                if (options.connectionOptions) {
                    Object.keys(options.connectionOptions).forEach(key => {
                        if (connectionOptions[key]) {
                            options.connectionOptions[key] = connectionOptions[key]
                        } else {
                            options.connectionOptions[key] = (iotDevice.configuration!.configuration as any)[key]
                        }
                    })
                    Object.keys(connectionOptions).forEach(key => {
                        if (options.connectionOptions[key] == null && connectionOptions[key] != null) {
                            options.connectionOptions[key] = connectionOptions[key]
                        }
                    })
                } else {
                    options.connectionOptions = connectionOptions
                }
            } else {
                options = { connectionOptions: connectionOptions }
            }
            return new IoTDeviceConfigurationParse2(undefined).setConfiguration$(this.progetto?.objectId!, options, iotDevice.seriale).pipe(
                map(el => {
                    return {
                        item: iotDevice,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                    }
                })
            )
        }
        return fetchPage$(0).pipe(
            expand(({ nextPage }) => nextPage ? fetchPage$(nextPage) : EMPTY)
        )


    }

}


